module.exports = __webpack_public_path__ + "img/timeLine-one-hover.4fd9fa97.png";